module.exports = __webpack_public_path__ + "media/images/iconSettings__accent--dark-9c2a255f9c3db237130c8ead32e8376c.png";